/**
 * Created by Ram on 14/09/2016.
 */

import React from 'react';

const Footer = () => (
    <footer className="navbar-fixed-bottom footer portalFooter">
        <div className="container-fluid">
            <div className="row footer-list footerStyles">
                <div className="col-xs-12 col-sm-5 col-sm-offset-4">
                    <ul className="list-unstyled list-inline text-center no-text-center">
                        <li>
                            <a href="https://bluedotinnovation.atlassian.net/secure/RapidBoard.jspa" target="_blank">
                                Jira
                            </a>
                        </li>
                        <li>
                            <a href="https://bluedotinnovation.atlassian.net/wiki/spaces/TEST/overview" target="_blank">
                                QA | Confluence
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://bluedotinnovation.atlassian.net/wiki/spaces/BKB/pages/506788/Asset+Registry+for+Mobile+Devices"
                                target="_blank"
                            >
                                Device Registry | Confluence
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-xs-12 col-sm-3">
                    <span className="pull-right">&copy; Bluedot Innovation 2019</span>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;